import { withStyles, Button } from '@material-ui/core';
import DateRange from '@material-ui/icons/DateRange';

const styles = (theme) => ({
  wrapper: {
    height: 34,
    border: `1px solid ${theme.iconColor}`,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 8,
    paddingRight: 8,
    fontSize: 12,
    cursor: 'pointer',
    color: theme.gridTextColor,
    justifyContent: 'flex-start',
    '&:hover': {
      background: theme.ModalBGColor
    },
  },
  dateIcon: {
    marginLeft: 8
  },
  fitMaxContent: {
    minWidth: 'max-content'
  },
  containerLabelClass: {
    position: 'absolute',
    padding: '0 4',
    backgroundColor: theme.ModalBGColor,
    fontSize: theme.headerTextFontSize,
    color: theme.iconColor,
    transform: `translate(-11px, -17px) scale(0.75)`
  }
});
const DateRangeInputBox = ({
  classes,
  startDate,
  endDate,
  onClick,
  labelText,
  fullWidth,
}) => (
  <Button
    disableRipple
    className={`${classes.wrapper} ${fullWidth ? classes.fitMaxContent : ''}`}
    onClick={onClick}>
    {labelText && <span className={classes.containerLabelClass}>{labelText}</span>}
    <span>{`${startDate} - ${endDate}`}</span>
    <DateRange className={classes.dateIcon} />
  </Button>
);

export default withStyles(styles)(DateRangeInputBox);
